import { ajax } from '../../../services/helper'
class ApiService {

    getTeamsData = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/teamList"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     getEmployeeById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     addEmployeeAttrition = (data,employeeId) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/"+employeeId+"/attrite"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    getAttritionReasonList = (type) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/reasons/getCombo?type="+type
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    } 

    
      getEmployeeViewById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/"+id+"/view"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Teams/services/apiservices.js